import { useQuery } from '@ts-core/lib/apollo';

import { StudentActivity } from '@ts-core/modules/activities/types';
import { getActivityQuery, GetActivityQueryResult, GetActivityQueryVariables } from '../graphql/queries/getActivityByIdQuery';

export interface ActivityHookInput {
  courseId: string;
  activityId: string;
}

export interface ActivityHookPayload {
  activity?: StudentActivity;
  loading: boolean;
}

export default function useActivity({ courseId, activityId }: ActivityHookInput): ActivityHookPayload {
  const { data, loading } = useQuery<GetActivityQueryResult, GetActivityQueryVariables>(getActivityQuery, {
    variables: { courseId, activityId },
    fetchPolicy: 'cache-and-network',
  });

  return {
    activity: data?.activity,
    loading,
  };
}
